<template>
	<div class="index index_content">
		<el-form class="elformSty filxwrap boxsizing" label-position="top">
			<div class="marbtnclsty">
				<el-form-item>
					<el-select class="allwidsty" placeholder="点此切换年级考测评" v-model="level" @change="handleSelectChange">
						<el-option v-for="(item,i) in levelList" :key="i" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<img src="../../assets/imgs/qiehuan@2x.png" />
				</el-form-item>
			</div>
		</el-form>
		<div class="con_tabbox">
			<div :class="tabindex == 1 ?'con_tab_active':''" @click="tabFun(1)">AI测评试题</div>
			<div :class="tabindex == 2 ?'con_tab_active':''" @click="tabFun(2)">测评记录</div>
		</div>
		<div class="con_tab_data">
			<div v-if="tabindex == 1">
				<div v-if="datalist.length>0">
					<div class="item" @click="clickFun(item.id,item.name,item.time)" v-for="(item,index) in datalist"
						:key="index">
						<div class="item_left">
							<div>{{item.name}}</div>
							<div class="num">已测试 {{item.num}} 次</div>
						</div>
						<img class="item_right_img" src="../../assets/imgs/right.png" />
					</div>
				</div>
				<div class="zanwu" v-else>暂无数据</div>
			</div>
			<div v-if="tabindex == 2">
				<div v-if="recordList.length>0">
					<div class="item" v-for="(item,index) in recordList" :key="index">
						<div class="item_left" @click="SeeAnswerFun(item.id)">
							<div>{{item.name}}</div>
							<div class="num">{{item.createtime}}</div>
						</div>
						<div class="item_right" @click="downloadFun(item.id)">
							报告<img src="../../assets/imgs/icon_p14@2x.png" />
						</div>
					</div>

				</div>
				<div class="zanwu" v-else>暂无数据</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: "index",
		data() {
			return {
				tabindex: 1,
				level: '',
				levelList: [],
				datalist: [], //测评试题列表
				recordList: [], //测评记录列表
			};
		},
		computed: {

		},

		mounted() {
			this.gradeFun();
			localStorage.removeItem('totalTime'); //清除倒计时缓存
		},
		methods: {
			// 获取年级方法
			gradeFun(){
				var that = this;
				this.$api.POST(this.$face.index_grade, function(res) {
					that.levelList = res.data;
					// that.level = res.data[0].id;
					that.initFun();
				});
			},
			//点击切换试题-测评记录
			tabFun(i) {
				this.tabindex = i;
				this.handleSelectChange();
			},
			// 切换
			handleSelectChange(){
				if (this.tabindex == 1) {
					this.initFun()
				} else if (this.tabindex == 2) {
					this.recordGetList()
				}
			},
			clickFun(id, name, time) {
				localStorage.removeItem('isSeeAnswer'); //清除答案解析缓存

				localStorage.removeItem('totalTime'); //清除倒计时缓存
				localStorage.removeItem('Time'); //清除倒计时缓存

				// console.log('id', id)
				this.$router.push({
					name: 'Answer',
					query: {
						id: id,
						name: name,
						time: time
					}
				});
			},
			//题库列表
			initFun() {
				var that = this
				this.$api.POST(this.$face.index_getList, {
					type: this.level
				}, function(res) {
					that.datalist = res.data
				});
			},
			//测评记录列表
			recordGetList() {
				var that = this
				this.$api.POST(this.$face.index_questionLog, {
					type: this.level
				}, function(res) {
					that.recordList = res.data
				});
			},

			userProfileFun() {
				var that = this
				var data = {
					grade: this.level, //是 string 年级： 
				}
				this.$api.POST(this.$face.user_profile, data, function(res) {});
			},

			//下载报告
			downloadFun(id) {
				// this.$router.push({
				// 	name: 'evaluationReport',
				// 	query: {
				// 		id: id
				// 	}
				// })
				const routeData = this.$router.resolve({
					name: 'evaluationReport',
					query: {
						id: id
					}, //参数
				});
				window.open(routeData.href, '_blank');
			},
			//查看答案和解析
			SeeAnswerFun(id) {
				localStorage.setItem('isSeeAnswer', true); //设置为true（可查看答案和解析）
				const routeData = this.$router.resolve({
					name: 'Answer',
					query: {
						reportID: id
					}, //参数
				});
				window.open(routeData.href, '_blank');
			},


		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.index {
		position: relative;
	}
	.marbtnclsty img {
		width: 14px;
		height: 14px;
		margin-left: -22px;
	}

	.marbtnclsty>>>.el-form-item__label::before,
	.marbtnclsty>>>.el-form-item__label::before,
	.marbtnclsty>>>.el-select .el-input .el-select__caret {
		display: none !important;
	}


	.elformSty>>>.el-input__inner {
		/* width: 100% !important;
		height: 50px !important;
		border: none !important;
		line-height: 50px !important;
		border-radius: 8px !important;
		background: rgba(246, 250, 255, 1) !important; */
		border: 1px solid rgba(62, 136, 254, 1) !important;
		display: flex;
		align-items: center;
		justify-content: space-between;
		opacity: 1;
		/** 文本1 */
		width: 165px;
		height: 30px;
		border-radius: 5px;
		background: rgba(7, 49, 144, 0);
		box-sizing: border-box;
		padding: 0 8px;
		cursor: pointer;
		color: rgba(62, 136, 254, 1) !important;
	}

	.elformSty>>>.el-input__inner::placeholder {
		font-size: 14px;
		font-weight: 500;
		color: rgba(62, 136, 254, 1) !important;
	}

	.con_tabbox {
		margin: 10px 0;
		width: 100%;
		height: 70px;
		opacity: 1;
		border-radius: 5px;
		background: rgba(255, 255, 255, 1);
		padding: 10px 15px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.con_tabbox div {
		width: 580px;
		height: 50px;
		opacity: 1;
		border-radius: 5px;
		cursor: pointer;
		font-size: 18px;
		letter-spacing: 0px;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
	}

	.con_tab_active {
		background: rgba(78, 142, 255, 1) !important;
		color: rgba(255, 255, 255, 1) !important;
		font-weight: 700 !important;
	}

	.con_tab_data {
		width: 100%;
		opacity: 1;
		border-radius: 5px;
		background: rgba(255, 255, 255, 1);
		box-sizing: border-box;
		padding: 0 30px;
	}

	.con_tab_data .item {
		width: 100%;
		box-sizing: border-box;
		padding: 15px 30px 15px 48px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		justify-content: space-between;
		/** 文本1 */
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		color: rgba(51, 51, 51, 1);
		cursor: pointer;
	}

	.con_tab_data .item .num {
		font-size: 12px;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		margin-top: 10px;
	}


	.con_tab_data .item .item_right {
		width: 80px;
		height: 30px;
		opacity: 1;
		border-radius: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid rgba(0, 0, 0, 1);
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(78, 142, 255, 1);

	}

	.con_tab_data .item .item_right img {
		width: 16px;
		height: 16px;
		margin-left: 8px;
	}

	.con_tab_data .item .item_right_img {
		width: 30px;
	}

	.con_tab_data .item:last-child {
		border-bottom: none;
	}

	@media screen and (max-width:1200px) {
		.index {
			padding: 16px;
		}
	}

	@media screen and (max-width:600px) {
		.con_tabbox div {
			height: 40px;
			font-size: 16px;
		}

		.con_tabbox {
			height: 60px;
			margin-top: 0;
		}

		.con_tab_data {
			background: none;
			padding: 0;
		}

		.con_tab_data .item {
			background-color: #fff;
			border: none;
			margin-bottom: 10px;
			border-radius: 8px;
			padding: 15px 20px;
		}

		.index {
			margin-top: -40px;
			padding-top: 70px;
		}

		.index .elformSty {
			/* display: none; */
			position: absolute;
			top: 0px;
			left: 0px;
			right: 0px;
			height: 50px;
			margin-bottom: 20px;
			padding: 5px 31px;
			background-color: #ffffff;
		}

	}

	.zanwu {
		text-align: center;
		padding: 30px 0;
	}
</style>